export const DOCUMENT_HEADER_ID = 'document-header';
export const TABLE_OF_CONTENT_ID = 'table-of-contents';
